import { render, staticRenderFns } from "./MyFooter.vue?vue&type=template&id=445e537e&scoped=true"
var script = {}
import style0 from "./MyFooter.vue?vue&type=style&index=0&id=445e537e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e537e",
  null
  
)

export default component.exports